import { toast } from "vue3-toastify";
import { i18n } from "./../lang";
import {integrationService} from "@/services/integrationService";
import {parseConfig} from "@/helpers/integration";

const state = {
    integrations: [],
    isAddingIntegration: false,
    editingIntegration: false,
    editIntegrationRequest: {
        loading: false,
    },
    addIntegrationRequest: {
        loading: false,
    },
    getIntegrationRequest: {
        loading: false,
    },
    deleteIntegrationRequest: {
        loading: false,
    },
    syncUserIntegrationsRequest: {
        loading: false,
    },
    newIntegrationUserId: null
}

const mutations = {
    setEditingIntegration(state, editingIntegration) {
        state.editingIntegration = editingIntegration;
        state.isAddingIntegration = false;
    },
    setGetIntegrationRequest(state, {loading, message}) {
        state.getIntegrationRequest = {
            loading: loading,
            message: message,
        }
    },
    setAddIntegrationRequest(state, {loading, message}) {
        state.addIntegrationRequest = {
            loading: loading,
            message: message,
        }
    },
    setEditIntegrationRequest(state, {loading, message}) {
        state.editIntegrationRequest = {
            loading: loading,
            message: message,
        }
    },
    setDeleteIntegrationRequest(state, {loading, message}) {
        state.deleteIntegrationRequest = {
            loading: loading,
            message: message,
        }
    },
    setSyncUserIntegrationsRequest(state, {loading, message}) {
        state.syncUserIntegrationsRequest = {
            loading: loading,
            message: message,
        }
    },
    setNewIntegrationUserId(state, userId) {
        state.newIntegrationUserId = userId;
    },
    updateIntegration(state, list){
        state.integrations = list
    },
    setIsAddingIntegration(state, isAddingIntegration){
        state.isAddingIntegration = isAddingIntegration;
        state.editingIntegration = false
    }
}

const actions = {
    getIntegration({commit}) {
        commit('setGetIntegrationRequest', {loading: true});
        integrationService.getIntegration()
            .then((response) => {
                commit('setGetIntegrationRequest', {loading: false});
                commit('updateIntegration', response.data);
            })
            .catch((error) => {
                commit('setGetIntegrationRequest', {loading: false, message: error});
            })
    },
    deleteIntegration({commit, state}, integration) {
        integrationService.deleteIntegration(integration)
            .then(() => {
                toast.success(i18n.global.t("toast.deleteSuccess"));
                const updatedList = state.integrations.filter(x => x.id !== integration.id);
                commit('updateIntegration', updatedList);
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.deleteError"));
                commit('setDeleteIntegrationRequest', {loading: false, message: error});
            })
    },
    addIntegration({commit, state}, integration) {
        commit('setAddIntegrationRequest', {loading: true});
        integrationService.saveIntegration(integration, false)
            .then((response) => {
                toast.success(i18n.global.t("toast.createSuccess"));
                commit('setAddIntegrationRequest', {loading: false});
                commit('updateIntegration', [...state.integrations, response.data]);
                commit('setIsAddingIntegration', false);
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.createError"));
                commit('setAddIntegrationRequest', {loading: false, message: error});
            })
    },
    syncUserIntegrations({commit, dispatch, state}, {userId, assigned, removed}) {
        commit('setSyncUserIntegrationsRequest', {loading: true});
        const assignCalls = assigned.map(integration => integrationService.saveIntegration({
            ...parseConfig(integration.configJson),
            id: integration.id,
            orgId: integration.orgId,
            userId,
            type: integration.type
        }, true));
        const deleteCalls = removed.map(integration => integrationService.deleteIntegration(integration));
        return Promise.all([...assignCalls, ...deleteCalls])
            .then(() => {
                const assignedIds = assigned.map(integration => integration.id);
                const removedIds = removed.map(integration => integration.id);
                const updatedList = state.integrations
                    .filter(integration => !removedIds.includes(integration.id))
                    .map(integration => assignedIds.includes(integration.id) ? {...integration, userId} : integration);
                commit('updateIntegration', updatedList);
                commit('setSyncUserIntegrationsRequest', {loading: false});
                return true;
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit('setSyncUserIntegrationsRequest', {loading: false, message: error});
                dispatch('getIntegration');
                return false;
            });
    },
    updateIntegration({commit, state}, integration) {
        commit('setEditIntegrationRequest', {loading: true});
        integrationService.saveIntegration(integration, true)
            .then((response) => {
                toast.success(i18n.global.t("toast.successEdit"));
                commit('setEditIntegrationRequest', {loading: false});
                const updatedIntegration = state.integrations.map(x =>
                    x.id === integration.id ? {...x, ...response.data, orgId: x.orgId} : x
                );
                commit('updateIntegration', updatedIntegration);
                commit('setEditingIntegration', null);
            })
            .catch((error) => {
                toast.error(i18n.global.t("toast.errorEdit"));
                commit('setEditIntegrationRequest', {loading: false, message: error});
            })
    },
}

export const integration = {
    namespaced: true,
    state,
    mutations,
    actions
}